// lib/mock/dashboard.ts
import type { DashboardStats, RecentOrder, SalesChartData } from "@/types";

// ─── آمار کلی (آیکون‌های توپر و رنگی شبیه Materio) ───
export const MOCK_STATS = [
  {
    id: "revenue",
    title: "درآمد کل",
    value: "۱۲۵,۰۰۰,۰۰۰",
    unit: "تومان",
    change: 12.5,
    icon: "DollarSign",
    solidColor: "bg-[#28C76F]", // سبز توپر Materio
  },
  {
    id: "orders",
    title: "سفارشات",
    value: "۱,۲۴۸",
    unit: "سفارش",
    change: 8.2,
    icon: "ShoppingCart",
    solidColor: "bg-[#00CFE8]", // آبی فیروزه‌ای توپر
  },
  {
    id: "products",
    title: "محصولات",
    value: "۳۴۲",
    unit: "محصول",
    change: -2.1,
    icon: "Package",
    solidColor: "bg-[#FF9F43]", // نارنجی توپر
  },
  {
    id: "users",
    title: "کاربران",
    value: "۸,۵۶۰",
    unit: "کاربر",
    change: 15.3,
    icon: "Users",
    solidColor: "bg-[#7367F0]", // بنفش توپر
  },
];

// ─── نمودار فروش (۷ روز اخیر) ───
export const MOCK_SALES_CHART = [
  { date: "شنبه", sales: 12500000, orders: 120 },
  { date: "یکشنبه", sales: 18200000, orders: 180 },
  { date: "دوشنبه", sales: 15800000, orders: 150 },
  { date: "سه‌شنبه", sales: 22400000, orders: 220 },
  { date: "چهارشنبه", sales: 19800000, orders: 190 },
  { date: "پنجشنبه", sales: 25600000, orders: 250 },
  { date: "جمعه", sales: 14200000, orders: 140 },
];

// ─── سفارشات اخیر ───
export const MOCK_RECENT_ORDERS = [
  {
    id: "KH-1403-45821",
    customerName: "علی محمدی",
    customerAvatar: "ع",
    amount: 1566530,
    status: "shipping",
    createdAt: Date.now() - 3 * 3600000,
  },
  {
    id: "KH-1403-45830",
    customerName: "سارا احمدی",
    customerAvatar: "س",
    amount: 537150,
    status: "pending",
    createdAt: Date.now() - 30 * 60000,
  },
  {
    id: "KH-1403-45790",
    customerName: "رضا کریمی",
    customerAvatar: "ر",
    amount: 714710,
    status: "confirmed",
    createdAt: Date.now() - 86400000,
  },
  {
    id: "KH-1403-45680",
    customerName: "مریم صادقی",
    customerAvatar: "م",
    amount: 525150,
    status: "delivered",
    createdAt: Date.now() - 2 * 86400000,
  },
  {
    id: "KH-1403-45510",
    customerName: "حسین بیات",
    customerAvatar: "ح",
    amount: 171600,
    status: "canceled",
    createdAt: Date.now() - 3 * 86400000,
  },
];

// ─── فعالیت‌های اخیر (Activity Timeline) ───
export const MOCK_ACTIVITIES = [
  {
    id: 1,
    title: "سفارش جدید ثبت شد",
    description: "سفارش KH-1403-45830 توسط سارا احمدی",
    time: "۳۰ دقیقه پیش",
    icon: "ShoppingCart",
    color: "text-blue-600",
    bgColor: "bg-blue-100 dark:bg-blue-500/20",
  },
  {
    id: 2,
    title: "پرداخت موفق",
    description: "مبلغ ۱,۵۶۶,۵۳۰ تومان از علی محمدی دریافت شد",
    time: "۳ ساعت پیش",
    icon: "CreditCard",
    color: "text-emerald-600",
    bgColor: "bg-emerald-100 dark:bg-emerald-500/20",
  },
  {
    id: 3,
    title: "محصول جدید اضافه شد",
    description: "پودر قهوه کلاسنو توسط مدیر کل",
    time: "۵ ساعت پیش",
    icon: "Package",
    color: "text-orange-600",
    bgColor: "bg-orange-100 dark:bg-orange-500/20",
  },
  {
    id: 4,
    title: "تیکت پشتیبانی پاسخ داده شد",
    description: "تیکت TK-2401-88472 توسط پشتیبان",
    time: "دیروز",
    icon: "Headphones",
    color: "text-purple-600",
    bgColor: "bg-purple-100 dark:bg-purple-500/20",
  },
];

// ─── منابع ترافیک ───
export const MOCK_TRAFFIC_SOURCES = [
  { source: "جستجوی گوگل", percentage: 45, color: "bg-blue-500" },
  { source: "شبکه‌های اجتماعی", percentage: 30, color: "bg-pink-500" },
  { source: "تبلیغات مستقیم", percentage: 15, color: "bg-amber-500" },
  { source: "ورودی مستقیم", percentage: 10, color: "bg-gray-400" },
];